function initTooltips(scope = document) {
    if (!window.tippy) return;

    scope.querySelectorAll('[data-tippy-content]').forEach((el) => {
        if (el._tippy) {
            // node reused by morph: refresh content only
            el._tippy.setContent(el.dataset.tippyContent);
            return;
        }

        tippy(el, {
            allowHTML: true,
            interactive: true,
            appendTo: (reference) => reference.closest('dialog') || document.body,
            popperOptions: {
                modifiers: [
                    {
                        name: 'arrow',
                        options: {
                            padding: 5
                        }
                    }
                ]
            }
        });
    });
}

document.addEventListener('DOMContentLoaded', () => initTooltips());
document.addEventListener('shopify:section:load', (e) => initTooltips(e.target));
document.addEventListener('theme:tooltips:init', (e) => initTooltips(e.detail?.scope || document));
